import React from 'react';
import { Branding } from './Branding';
import { FooterNavigation, FooterNavigationProps } from './FooterNavigation/FooterNavigation';
import { styles } from './FooterLayout.css';
import { Legals } from './Legals';
import { LegalsProps } from './Legals/Legals';
import { PaymentOptions, PaymentOptionsProps } from './PaymentOptions/PaymentOptions';
import { Socials, SocialsProps } from './Socials/Socials';
import { SubscribeBanner } from './Subscribe';
import { SubscribeBannerProps } from './Subscribe/SubscribeBanner';
import { ContentBlock } from '../ContentBlock/ContentBlock';
import { trackingContext, TrackingProvider } from '../Tracking';

export type FooterLayoutProps = {
  subscribeProps: SubscribeBannerProps;
  navigationProps?: FooterNavigationProps;
  socialsProps?: SocialsProps;
  paymentOptionsProps?: PaymentOptionsProps;
  legalsProps?: LegalsProps;
  tagline: string;
};

export const FooterLayout = ({
  subscribeProps,
  navigationProps,
  socialsProps,
  paymentOptionsProps,
  legalsProps,
  tagline,
}: FooterLayoutProps) => {
  return (
    <TrackingProvider context={trackingContext.footer} shouldInheritFromParentContexts>
      <div className={styles.container}>
        {subscribeProps?.enabled ? (
          <ContentBlock backgroundColor="primary.main" paddingX={'small'} paddingY={'xlarge'}>
            <SubscribeBanner {...subscribeProps} />
          </ContentBlock>
        ) : null}
        <ContentBlock className={styles.contentMiddle} backgroundColor="secondary.main" paddingX={'small'}>
          <div className={styles.contentMiddleWrapper}>
            <div className={styles.contentLeft}>
              <Branding tagline={tagline} />
              {socialsProps ? <Socials {...socialsProps} /> : null}
            </div>
            {navigationProps ? <FooterNavigation {...navigationProps} /> : null}
            {paymentOptionsProps ? <PaymentOptions {...paymentOptionsProps} /> : null}
          </div>
        </ContentBlock>
        <ContentBlock
          className={styles.contentBottomWrapper}
          backgroundColor="secondary.main"
          paddingX={'small'}
          paddingBottom={'large'}
        >
          {legalsProps ? <Legals {...legalsProps} /> : null}
        </ContentBlock>
      </div>
    </TrackingProvider>
  );
};
